"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _r = _interopRequireDefault(require("refractor/lang/r.js"));

;
var _default = _r.default;
exports.default = _default;